"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const getSiteOfficeIncludedItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('offices'),
    attributes: zod_1.z.object({
        name: zod_1.z.string(),
    }),
});
exports.getSiteApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('sites'),
        attributes: zod_1.z.object({
            name: zod_1.z.string(),
        }),
        relationships: zod_1.z.object({
            offices: (0, api_1.apiEntityRelationshipsSchema)('offices').optional(),
        }),
    }),
    included: zod_1.z
        .array(getSiteOfficeIncludedItemApiResponseSchema)
        .optional()
        .default([]),
});
